import React, { useEffect, useState } from 'react'
import Header from './Components/Header'
import Footer from '../../../../Components/Footer/Footer'
import Banner from './Components/Banner'
import RelatedCourses from './Components/RelatedCourses'
import Teacher from './Components/Teacher'
import Details from './Components/Details'
import CourseStore from '../../Store/CourseStore'
import UserStore from '../../../UserAuth/Store/UserStore'
import withStore from '../../../../Components/Unstated/withStore'
import Loading from '../../../../Components/Loading/Loading'
import './Dashboard.sass'
import Helmet from '../../../../Components/Helmet/Helmet'
import { getCourseKeywords } from '../../Helpers/Keywords'
import { courseDashboardSchema } from './Schema'
import Button from '../../../../Components/Buttons/Button'
import ReactPixel from 'react-facebook-pixel'
import Recorded from './Recorded'
import GroupRegistration from './Components/GroupRegistration'
import Success from '../../../../Components/Success/Success'
import { withRouter } from 'react-router-dom'
import { getNextClass } from '../../Helpers/Timings'
import Faq from './Components/Faq'

const Dashboard = ({
  userStore: { state: user },
  state: { livDemyID, courseUrl },
  preview,
  courseStore: {
    state: {
      id,
      name,
      instruments,
      teacher: { name: teacherName },
      description,
      cover,
      preRequisites,
      fee,
      type,
      batches,
      isGroupCourse,
      isAuditionVideoReq,
      isApprovalReq,
      pendingEnrollmentRequest = false,
      isEnrolled = false,
      enrollments,
    },
    init,
    enroll,
    deleteRegistration,
  },
  courseData,
  admin,
  history,
}) => {
  const [editMode, toggleEditMode] = useState(false)
  const [loading, setLoading] = useState(false)
  const [groupReg, toggleGroupReg] = useState(false)
  const [success, setSuccess] = useState(false)
  const nextClass = isEnrolled && getNextClass(enrollments)

  useEffect(() => {
    ;(async () => {
      if (preview) {
        setLoading(true)
        const isValidCourse = await init({
          livDemyID,
          courseURL: courseUrl,
          user,
        })
        setLoading(false)
        if (!isValidCourse) {
        }
      } else if (courseData) {
        await init({ ...courseData, user, admin })
      }
    })()
  }, [init, livDemyID, courseUrl, courseData, user, preview, admin])

  useEffect(() => {
    if (!loading) {
      ReactPixel.track('ViewContent', {
        content_ids: [id],
        content_name: name,
        currency: fee?.currency,
        value: fee?.amount,
        content_type: 'product',
      })
    }
  }, [loading, id, name, fee])

  const pendingGroupEnrollment =
    type === 'live' &&
    isGroupCourse &&
    (pendingEnrollmentRequest ||
      (enrollments[0]?.billStatus && enrollments[0]?.billStatus === 'NOT_PAID'))

  return (
    <>
      {loading ? (
        <div className='courseDashboardLoader'>
          <Loading />
        </div>
      ) : type === 'recorded' ? (
        <Recorded />
      ) : (
        <div className='courseDashboard'>
          {admin && (
            <Button
              onClick={() => toggleEditMode(!editMode)}
              name={editMode ? 'Save Changes' : 'Edit Course'}
              type={'primary'}
              className={'editButton'}
            />
          )}
          <Helmet
            data={{
              title: `${name} by ${teacherName} | LivDemy`,
              description: description,
              image: cover,
              keywords: getCourseKeywords(teacherName, instruments),
              schema: courseDashboardSchema({
                name,
                teacherName,
                cover,
                instruments,
                description,
                preRequisites,
              }),
            }}
          />
          <Header
            restricted={!!preview || admin}
            editMode={editMode}
            groupReg={toggleGroupReg}
          />
          <Banner />
          <Details restricted={!!preview || admin} editMode={editMode} />
          <Teacher restricted={!!preview || admin} />
          <Faq />
          {!preview && !admin && (
            <RelatedCourses restricted={!!preview || admin} />
          )}
          {!preview && !admin && <Footer restricted={!!preview || admin} />}
          {groupReg && (
            <GroupRegistration
              close={() => toggleGroupReg(false)}
              batches={
                pendingEnrollmentRequest ? pendingEnrollmentRequest : batches
              }
              withAuditionVid={isAuditionVideoReq}
              withApproval={isApprovalReq}
              mode={
                isEnrolled && nextClass
                  ? 'ENROLLED'
                  : pendingEnrollmentRequest
                  ? 'PENDING'
                  : 'REGISTER'
              }
              pendingGroupEnrollment={pendingGroupEnrollment}
              onSubmit={async (message, id, videoURL) => {
                if (pendingEnrollmentRequest) await deleteRegistration(id)
                else if (!isEnrolled || !nextClass) {
                  const success = await enroll(message, id, videoURL)

                  toggleGroupReg(false)
                  if (!isApprovalReq && success.status !== 'PAID') {
                    history.push(`/billing/payment/${success.billId}`)
                    window.location.reload()
                  } else setSuccess(true)
                }
              }}
            />
          )}
          {success && (
            <Success
              heading={`Your enrollment request for the course ${name} has been sent to ${teacherName}`}
              subText={`You will be notified when ${teacherName} accepts your enrollment requests.`}
              secondary={{
                hidden: true,
              }}
              primary={{
                name: 'Go to home',
                route: '/',
              }}
            />
          )}
        </div>
      )}
    </>
  )
}

export default withStore([UserStore, CourseStore])(withRouter(Dashboard))

Dashboard.defaultProps = {
  state: {},
  admin: false,
}
